import type { MediaKind } from '@bia-auction/shared-schema';
import { API_BASE } from './config';
import { getAccessToken } from './token-store';

/**
 * Two of the four `MEDIA_KINDS` are moving pictures, and every surface that renders a gallery
 * has to pick `<video>` over `<img>` for them — an `<img src>` pointed at an mp4 is a broken
 * image icon, not a fallback.
 */
export function isVideoKind(kind: MediaKind): boolean {
  return kind === 'video' || kind === 'damage_video';
}

/**
 * Resolve an API-relative media path (`/api/v2/media/vehicles/…`) to something an `<img>` can
 * load from the admin origin.
 *
 * Two things happen here. The path is prefixed with the API origin, because the SPA runs on a
 * separate Pages origin (ADR 0019). And the access token is appended as `?token=` — a browser
 * cannot attach an `Authorization` header to an `<img src>`, and most admin vehicles are not
 * on a public lot, so their photos are gated. This mirrors the realtime route's `?token=`
 * handshake rather than inventing a second scheme; the server answers gated media `private`
 * so no shared cache retains it.
 */
export function mediaSrc(path: string | null | undefined): string | undefined {
  if (!path) return undefined;
  const origin = API_BASE.replace(/\/api\/v2$/, '');
  const token = getAccessToken();
  return `${origin}${path}${token ? `?token=${encodeURIComponent(token)}` : ''}`;
}
